import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ISubTaxCode } from './models/sub-tax-code.model';
import { ITaxCountry } from './models/tax-country.model';

@Injectable({
  providedIn: 'root'
})
export class TaxrateService {


  constructor(private http: HttpClient) { }

  getAllGroups() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getAllDiscountTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }
 
  getTaxList() {
    return this.http.get<any>(`${environment.inventoryURl}Tax`);
  }

  getSetTaxConfig(status) {
    let params = new HttpParams();
    params = (status==undefined)? params: params.append('taxEnableStatus', status)
    return this.http.get<any>(`${environment.inventoryURl}Tax/TaxConfiguration`, {params});
  }

  deleteTax(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Tax/${id}`)
    .toPromise()
      .then(res => res);
  }

  deleteTaxRate(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Tax/${id}`);
  }

  getVendorList() {
    let params = new HttpParams();
        params =  params.append('PageNumber', '0')
        params =  params.append('PageSize', '0')
        params = params.append('IsAscending', 'true')
        params = params.append('SortBy', 'CreatedDate')
    return this.http.get<any>(`${environment.inventoryURl}Vendor`,{params:params});
  }

  addTax(data) {
    return this.http.post<any>(`${environment.inventoryURl}Tax`, data)
      .toPromise()
      .then(res => res);
  }

  getTaxById(id: number) {
    return this.http.get<any>(`${environment.inventoryURl}Tax/${id}`);
  }

  updateTax(data) {
    return this.http.put<any>(`${environment.inventoryURl}Tax`, data)
      .toPromise()
      .then(res => res);
  }

  getAddressTypes() {
    return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
  }

  getAllSubTaxCodes(countryId: number) {
    return this.http.get<any>(`${environment.inventoryURl}SubTaxCode?countryId=${countryId}`);
  }

  addSubTaxCode(data: ISubTaxCode) {
    return this.http.post<any>(`${environment.inventoryURl}SubTaxCode`, data);
  }

  addTaxCountry(data: ITaxCountry) {
    return this.http.post<any>(`${environment.inventoryURl}Tax/TaxCountry`, data);
  }
}
